<div class="login-container">
  <div class="login-container__form">
    <div class="login-container__form__inner">
      <img
        class="login-container__form__inner__logo"
        src="../../assets/img/jt-logo-big.svg" />
      <h1>{{ translationPrefix + 'heading' | translate }}</h1>
      <div class="disclaimer">
        {{ translationPrefix + 'disclaimer' | translate }}
      </div>
      @if (hasError()) {
        <p-message severity="error" class="login-container__form__inner__err">
          <img src="assets/icons/warning.svg" />
          <span>
            @if (appleLoginFlowState() === 'ERROR') {
              {{ translationPrefix + 'error.generic' | translate }}
            } @else {
              @switch (loginFlowState()) {
                @case ('CREDENTIALS_NOT_FOUND') {
                  {{translationPrefix + 'error.creds-not-found' | translate }}
                }
                @case ('UNAUTHORIZED') {
                  {{translationPrefix + 'error.unauthorized' | translate }}
                }
                @default {
                  {{ translationPrefix + 'error.generic' | translate }}
                }
              }
            }
          </span>
        </p-message>
      }

      <div class="login-buttons">

        <button class="primary-btn" (click)="startLoginFlow()" [disabled]="loginFlowState().toString() === 'DISABLED'">
          @if (loginFlowState().toString() === 'IN_PROGRESS') {
            <span class="loader"></span>
          } @else {
            {{ translationPrefix + 'login-label' | translate }}
          }
        </button>

        <button class="primary-btn" (click)="appleIdLoginFlow()" [disabled]="appleLoginFlowState().toString() === 'DISABLED'">
          @if (appleLoginFlowState().toString() === 'IN_PROGRESS') {
            <span class="loader"></span>
          } @else {
            {{ translationPrefix + 'apple-login-label' | translate }}
          }
        </button>

      </div>

      <div class="login-container__form__inner__footer">
        <div class="login-container__form__inner__footer__label">
          {{ translationPrefix + 'footerLabel' | translate }}
        </div>
        <div class="login-container__form__inner__footer__value">
          {{ translationPrefix + 'footerValue' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="login-container__cover">
    <img
      class="login-container__cover__image"
      src="assets/img/krystal-bg-3%203x.jpg" />
  </div>
</div>
